/**
 * @author Javier Ojeda
 * @date 16/11/2018
 * @description: Actions relativas al modelo CountryLocal
 */

// @flow

import * as CountryLocalActionTypes from 'action_types/CountryLocalActionTypes';
import Dispatcher from 'dispatcher';
import ApiClient from 'utils/ApiClient';

class HomeActions {
  getPhoneCountryCodes(): Promise<any>  {
    return ApiClient.get({
      path: '/utilities/country_codes.json',
      skipApiUrl: true,
      data: {},
      success: codes => {
        Dispatcher.dispatch({
          type: CountryLocalActionTypes.SAVE_COUNTRY_CODES,
          codes: codes['country_codes']
        });
      }
    });
  }
}

export default new HomeActions();
